import { Outlet } from "react-router-dom";
import { NotificationPageNavigation } from "@/features/notifications/notification-page-navigation";
import { useI18n } from "@/locales/i18n-provider";
import { PageShell } from "@/surfaces/standalone/components/page-shell";

export function NotificationCenterLayout() {
  const { t } = useI18n();

  return (
    <PageShell fill title={t("notifications.centerTitle")} description={t("notifications.pageDescription")}>
      <div className="grid h-full min-h-0 min-w-0 flex-1 grid-cols-1 grid-rows-[auto_minmax(0,1fr)] gap-5 sm:grid-cols-[10rem_minmax(0,1fr)] sm:grid-rows-1 sm:gap-0">
        <NotificationPageNavigation />

        <div className="min-h-0 min-w-0 overflow-hidden sm:border-l sm:pl-5 lg:pl-6">
          <Outlet />
        </div>
      </div>
    </PageShell>
  );
}
